import React from 'react';

import { serverDateToLocal } from '../../../DateTimeUtils';
import { PropertyDetails } from '../../core';

export const DatePropertyDetails: React.FC<{ title: string; date: Date }> = ({ title, date }) => (
  <PropertyDetails title={title} text={date ? serverDateToLocal(date) : ''} />
);
